"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShakaEwmaBaseSmoother = void 0;
exports.createShakaEwmaCompositeConfig = createShakaEwmaCompositeConfig;
var composer_types_1 = require("../composers/composer-types");
var network_estimation_types_1 = require("../network-estimation-types");
// Inspired by Shaka's implementation of EWMA
var ShakaEwmaBaseSmoother = /** @class */ (function () {
    function ShakaEwmaBaseSmoother(getValueForSmoothing, _a, getValueForWeighting) {
        var halfLife = _a.halfLife;
        this.getValueForSmoothing = getValueForSmoothing;
        this.getValueForWeighting = getValueForWeighting;
        this.totalWeight = 0;
        this.alpha = Math.exp(Math.log(0.5) / halfLife);
    }
    ShakaEwmaBaseSmoother.prototype.sample = function (newSample) {
        // "Time Spent Downloading" is used to determine how much weighting a given sample
        // should be assigned. While using the "Sample Direct" we cannot provide a value, so
        // a sensible default of 1s is used.
        var _a;
        var weight = 1;
        if (this.getValueForWeighting) {
            var timeSpentDownloadingMs = this.getValueForWeighting(newSample);
            weight = timeSpentDownloadingMs ? timeSpentDownloadingMs / 1000 : 1;
        }
        var adjAlpha = Math.pow(this.alpha, weight);
        var value = this.getValueForSmoothing(newSample);
        var currentEstimate = (_a = this.estimate) !== null && _a !== void 0 ? _a : 0;
        this.estimate = value * (1 - adjAlpha) + adjAlpha * currentEstimate;
        this.totalWeight += weight;
    };
    ShakaEwmaBaseSmoother.prototype.getValue = function () {
        if (!this.estimate) {
            return;
        }
        var zeroFactor = 1 - Math.pow(this.alpha, this.totalWeight);
        return this.estimate / zeroFactor;
    };
    ShakaEwmaBaseSmoother.prototype.clear = function () {
        this.estimate = undefined;
        this.totalWeight = 0;
    };
    return ShakaEwmaBaseSmoother;
}());
exports.ShakaEwmaBaseSmoother = ShakaEwmaBaseSmoother;
// Inspired by Shaka's usage of two EWMA averages
// with a fast and slow half life.
function createShakaEwmaCompositeConfig(config) {
    // Default of 2 & 5 are aligned with Shaka's defaults as of v3.3.10
    // https://github.com/sky-uk/shaka-player/blob/sky-uk/v3.3.10/lib/util/player_configuration.js#L275
    var _a = config.fastHalfLife, fastHalfLife = _a === void 0 ? 2 : _a, _b = config.slowHalfLife, slowHalfLife = _b === void 0 ? 5 : _b, rest = __rest(config, ["fastHalfLife", "slowHalfLife"]);
    var fastConfig = __assign({ halfLife: fastHalfLife }, rest);
    var slowConfig = __assign({ halfLife: slowHalfLife }, rest);
    return {
        type: network_estimation_types_1.SmootherType.COMPOSITE,
        composerType: composer_types_1.ComposerType.LOWEST_VALUE,
        smootherConfigs: [
            __assign(__assign({}, fastConfig), { type: network_estimation_types_1.SmootherType.SHAKA_BASE_EWMA }),
            __assign(__assign({}, slowConfig), { type: network_estimation_types_1.SmootherType.SHAKA_BASE_EWMA }),
        ],
    };
}
